"use client";
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";

type styles = { styles?: { readonly [className: string]: string } };
type typeProp = "styleType";

type getStylesFunction<T extends { [key in typeProp]?: T[key] }> = (options: {
  [key in typeProp]?: T[key];
}) => {
  styleImport?: () => Promise<{ default: styles["styles"] }>;
};

type withCustomStylesOptions<T> = {
  typeProp?: typeProp;
  getStyles?: getStylesFunction<T>;
  styleProp?: string;
};

function withCustomStyles<T>(
  Component: React.ComponentType<T>,
  options: withCustomStylesOptions<T>,
) {
  const { getStyles, styleProp = "styles", typeProp = "styleType" } = options;

  const WrappingComponent: React.ComponentType<T> = (props: T) => {
    WrappingComponent.displayName = Component.displayName || Component.name;
    const [styles, setStyles] = useState<styles["styles"]>();
    const { styleImport } = getStyles?.({ [typeProp]: props[typeProp] }) || {};

    useEffect(() => {
      if (styleImport) {
        const setSliceStyles = async () => {
          const customStyles = await styleImport();
          setStyles(customStyles?.default);
        };
        setSliceStyles();
      }
    }, [styleImport]);

    if (!styleImport || styles) {
      const customStyles = styles ? { [styleProp]: styles } : {};
      return <Component {...(props as T)} {...customStyles} />;
    }
    return <></>;
  };
  return WrappingComponent;
}

export default withCustomStyles;
